import { lib as emojiMap } from 'emojilib'
import { has } from 'lodash'

/**
 *
 * @param {string} [str] The string to convert into an emoji, include the surrounding : :
 * @returns string
 */
export function toEmoji(str?: string | null) {
  if (!str) return str
  const replacedStr = str.replaceAll(/:(\w+):/gi, (match, emojiKey) => {
    return has(emojiMap, emojiKey) ? emojiMap[emojiKey].char : match
  })

  return replacedStr || ''
}
